import { useState, useCallback } from 'react'

interface Props {
  value: string
  className?: string
}

function CopyIcon() {
  return (
    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M5 15V5a2 2 0 0 1 2-2h10" />
    </svg>
  )
}

function CheckIcon() {
  return (
    <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  )
}

export function CopyField({ value, className = '' }: Props) {
  const [copied, setCopied] = useState(false)

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      // Clipboard API unavailable (e.g. non-secure context) — ignore silently
    }
  }, [value])

  return (
    <div className={`flex items-center gap-2 rounded-lg border-2 border-surface-lighter bg-surface px-3 py-2 ${className}`}>
      <span className="min-w-0 flex-1 truncate text-xs text-text-muted">{value}</span>
      <button
        type="button"
        onClick={handleCopy}
        className={`shrink-0 transition-colors ${copied ? 'text-primary' : 'text-text-muted hover:text-primary'}`}
        aria-label="Copy to clipboard"
      >
        {copied ? <CheckIcon /> : <CopyIcon />}
      </button>
    </div>
  )
}
